import { usePhotoViewContext } from "@/context/PhotoViewContext";
import "./NewTagPhoto.scss";
import { useEffect, useState } from "react";
import { GalleryI } from "@/interfaces/galleries/Galleries";
import { searchTextGalleryName } from "@/services/GalleriesService";
import CustomSpinner from "@/components/CustomSpinner/CustomSpinner";
import { notifyError } from "@/utils/NotificationFunctions";

interface NewTagPhotoI {
  x: number;
  y: number;
}

function NewTagPhoto(props: NewTagPhotoI) {
  const { addNewTag } = usePhotoViewContext();
  const { tags } = usePhotoViewContext();
  const { x, y } = props;
  const [searchText, setSearchText] = useState<string>("");
  const [debouncedText, setDebouncedText] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [galleries, setGalleries] = useState<Array<GalleryI>>([]);

  const handleNewTag = (gallery_id: string) => {
    setLoading(true);
    const indexGallery = tags.findIndex(
      (e: any) => e.gallery_id === gallery_id
    );

    if (indexGallery !== -1) {
      notifyError("This person is already tagged");
      setLoading(false);
    } else {
      addNewTag({ x, y, gallery_id });
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedText(searchText);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchText]);

  useEffect(() => {
    if (debouncedText.length > 2) {
      setLoading(true);

      searchTextGalleryName(debouncedText).then((res) => {
        if (res && res.status === "Success") {
          setGalleries(res.data);
          setLoading(false);
        }
      });
    } else {
      setGalleries([]);
    }
  }, [debouncedText]);

  return (
    <div className="new-tag" style={{ left: x, top: y }}>
      <div className="tag-search-container">
        <div className="c-row">
          <input
            type="text"
            id="tagName"
            name="tagname"
            placeholder="Enter a name"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="searched-tags-container">
          {loading && (
            <div className="w-100 p-3 d-flex justify-content-center">
              <CustomSpinner size={2} borderWidth={2} />
            </div>
          )}
          {!loading &&
            galleries.map((gallery) => {
              return (
                <div
                  className="tag-result"
                  key={gallery._id}
                  onClick={() => handleNewTag(gallery._id)}
                >
                  <p>{gallery.name}</p>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default NewTagPhoto;
